import style from "./TabbedButton.module.scss";
import { classNames } from '@progress/kendo-react-common';
import { Button } from "@progress/kendo-react-buttons";

export type TabbedButtonItem = {
    label: string;
}

export interface TabbedButtonProps {
    items: TabbedButtonItem[];
    activeIndex: number;
    onTabClick: (index: number) => void;
}

const TabbedButton: React.FC<TabbedButtonProps> = ({ items, activeIndex, onTabClick }) => {
    return (
        <div className={style.buttonContainer}>
            {items.map(({ label }, index) => (
                <Button
                    key={label}
                    className={classNames(style.button, { [style.active]: activeIndex === index })}
                    onClick={() => onTabClick(index)}
                >
                    {label}
                </Button>
            ))}
        </div>
    );
};

export default TabbedButton;
